export default __webpack_public_path__ + "static/media/640_private01-jp-mobile.dbe1dc70.png";